import { PartyType } from './../request-appointment/appointment.model';
export class BookingDetailModel {
  public id: string;
  public bookingREF: any;
  public date: any;
  public fromTime: any;
  public toTime: any;
  public clinic: string;
  public startTime: string;
  public endTime: string;
  public numberOfAttending: number;
  public travelDestination: Array<any>;
  public note: string;
  public departDate: string;
  public returnDate: string;
  public reasonsForTrip: string;
  public typeOfAccommodation: string;
  public groupName: string;
  public paymentTerm: string;
  public status: any;
  public clinicId: number = null;
  public members: any[];
  public bookingType: number = PartyType.Individual;
  public centre: any;
  public clinicName: string;
  public typeOfAccommodationId: any;
  public travelDestinationId: Array<any>;
  public reasonsForTripId: any;
  public typeOfAccommodationName: any;
  public travelDestinationName: any;
  public reasonsForTripName: any;
  public durationId: string = null;
  public duration: number;
  public administeredDate: any;
  public destination: any;
  public staffs: any[];
  public accomodationType : any;
}

export class CalendarModel {
    public bookingList: any[];
    public disableDates: any[];
    public disableTimes: any[];
}

export enum BookingStatus {
  NewBooking = 0,
  Confirmed = 1,
  Arrived = 2,
  DNA = 3,
  Cancelled = 4
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/models/view-schedule/booking-detail.model.ts